import * as coreApi from "api/Core";
import GenericListSelection, { IGenericListSelectionProps } from 'components/GenericListSelection';
import * as React from 'react';

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class UserListSelection extends React.Component<IGenericListSelectionProps> {

    render() {
        return (
            <GenericListSelection
                title="Pessoas"
                showThumbnail={true}
                multi={this.props.multi}
                onGetData={coreApi.getUserSelection}
                onSelect={this.props.onSelect}
            />
        );
    }
}

export default UserListSelection;